module.exports = __webpack_public_path__ + "img/banner_mobile.2fa336db.svg";